import { render } from "./NavDesktop.vue?vue&type=template&id=691c1e32"
import script from "./NavDesktop.vue?vue&type=script&lang=js"
export * from "./NavDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/builds/etos-b2b/b2b-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__